import axios from '../wmsAxios'

/*
 * 子流程管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/rfSubProcessDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/rfSubProcessDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/rfSubProcessDetail/findPage',
        method: 'post',
        data
    })
}

// 获取子流程名称列表
export const getSubProcessNames = (params) => {
    return axios({
        url: '/rfSubProcessDetail/getSubProcessNames',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/rfSubProcessDetail.js